import {XmaBusinessProfileFieldKey} from '@app/core/interfaces/xma-business-profile-result.interface';

export interface PersonalizationOption {
  key: XmaBusinessProfileFieldKey;
  label: string;
  chipLabel: string;
  value?: string;
  isActive: boolean;
}

export const PERSONALIZATION_OPTIONS: PersonalizationOption[] = [
  { key: 'businessName', label: 'استفاده از نام برند شما', chipLabel: 'نام برند', isActive: false },
  { key: 'businessTagline', label: 'افزودن شعار برند', chipLabel: 'شعار برند', isActive: false },
  { key: 'businessActivity', label: 'افزودن حوزه فعالیت', chipLabel: 'حوزه فعالیت', isActive: false },
  { key: 'businessContactNumber', label: 'درج شماره تماس در متن', chipLabel: 'شماره تماس', isActive: false },
  { key: 'businessUrl', label: 'افزودن لینک یا آیدی', chipLabel: 'لینک یا آیدی', isActive: false },
];
